export class KetoAlgParams {
  gender: number;
  age: number;
  weight: number;
  height: number;
  activityLevel: number;
  bodyfat: number;
  netCarbs: number;
  adjustment: number;
}

